module.exports = __webpack_public_path__ + "img/banner-bg-md-2x.677d1f3.png";